// Reverse of parseDecode
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const encodeStringify = (obj: any): string => encodeURIComponent(JSON.stringify(obj))

// Decode an object stored in cookie or attributes object inside html data attribute
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const parseDecode = (str: string): any => {
  try {
    return JSON.parse(decodeURIComponent(str))
  } catch {
    return str
  }
}
